export const PROGRAM_SETTING_RULES = {
  MINIMUM_INITIAL_DEPOSIT: 150000,
  MAXIMUM_INITIAL_DEPOSIT: 150000,
};

export const PROGRAM_SETTINGS = {
  GENERAL_SETTINGS_HEADER: 'Program Settings',
  DOCUMENT_LINKS_SETTINGS_HEADER: 'Document Links',

  DOCUMENT_LINKS_INDEX_FACT_SHEET: {
    LABEL: 'Index Fact Sheet Link',
  },

  INITIAL_DEPOSIT_CONTROLS: {
    LABEL: 'Initial Deposit Controls',
  },

  FEE_CONTROLS: {
    LABEL: 'Fee Controls',
    INCOMING_DOMESTIC_WIRE: {
      LABEL: 'Incoming Domestic Wire Fee',
    },
    OUTGOING_DOMESTIC_WIRE: {
      LABEL: 'Outgoing Domestic Wire Fee',
    },
    MONTHLY_SAVINGS_ACCOUNT_FEE: {
      LABEL: 'Monthly Savings Account Fee',
    },
  },

  CHECK_DEPOSIT_CONTROLS: {
    LABEL: 'Check Deposit Controls',
    MAX_DEPOSIT_PER_CHECK: {
      LABEL: 'Maximum Deposit Per Check',
    },
    MAX_DAILY_DEPOSIT_PER_BANK_ACCOUNT: {
      LABEL: 'Maximum Daily Deposit Per Bank Account',
    },
    MAX_MONTHLY_DEPOSIT_PER_BANK_ACCOUNT: {
      LABEL: 'Maximum Monthly Deposit Per Bank Account',
    },
    MAX_DAILY_DEPOSIT_PER_PROGRAM: {
      LABEL: 'Maximum Daily Deposit Per Program',
    },
  },

  CHECK_ISSUING_CONTROLS: {
    LABEL: 'Check Issuing Controls',
    PROGRAM_LEVEL_MAX_DAILY_CHECK_ISSUING_AMOUNT: {
      LABEL: 'Daily Maximum Check Issuing Amount',
    },
    BANK_ACCOUNT_LEVEL_MAX_DAILY_CHECK_ISSUING_AMOUNT: {
      LABEL: 'Daily Maximum Check Issuing Amount',
    },
    BANK_ACCOUNT_LEVEL_MAX_MONTHLY_CHECK_ISSUING_AMOUNT: {
      LABEL: 'Monthly Maximum Check Issuing Amount',
    },
    TRANSACTION_LEVEL_MAX_DAILY_PER_CHECK_AMOUNT: {
      LABEL: 'Maximum Amount Per Check ',
    },
  },

  ACH_CONTROLS: {
    LABEL: 'ACH Controls',
    PROGRAM_LEVEL_MAX_ACH_CREDIT: {
      LABEL: 'Maximum ACH Credit',
    },
    PROGRAM_LEVEL_MAX_ACH_DEBIT: {
      LABEL: 'Maximum ACH Debit',
    },
    BANK_ACCOUNT_LEVEL_MAX_ACH_CREDIT: {
      LABEL: 'Maximum ACH Credit',
    },
    BANK_ACCOUNT_LEVEL_MAX_ACH_DEBIT: {
      LABEL: 'Maximum ACH Debit',
    },
    TRANSACTION_LEVEL_MAX_ACH_CREDIT: {
      LABEL: 'Maximum ACH Credit',
    },
    TRANSACTION_LEVEL_MAX_ACH_DEBIT: {
      LABEL: 'Maximum ACH Debit',
    },
  },

  WIRE_CONTROLS: {
    LABEL: 'Wire Controls',
    PROGRAM_LEVEL_MAX_OUTGOING_WIRE: {
      LABEL: 'Maximum Outgoing Wire',
    },
    BANK_ACCOUNT_LEVEL_MAX_OUTGOING_WIRE: {
      LABEL: 'Maximum Outgoing Wire',
    },
    TRANSACTION_LEVEL_MAX_OUTGOING_WIRE: {
      LABEL: 'Maximum Outgoing Wire',
    },
    UNDER_REVIEW_WIRE_CONTROLS: {
      LABEL: 'Review Wire Requests Exceeding',
    },
  },
  SAVINGS_INTEREST_RATE_CONTROLS: {
    LABEL: 'Savings Interest Rate Controls',
    PROGRAM_LEVEL_SAVINGS_INTEREST_RATE: {
      LABEL: 'Savings Interest Rate',
    },
  },
};
